import NotFound from './components/NotFound.vue'
import Base from './components/Base.vue';
let routes = [
    { path: '/', redirect: '/home' },
    {
        path: '/', component: Base, name: 'Base', children: [
            { path: 'home', name: 'Home', component: function (resovle) { require(['./components/Home.vue'], resovle) } },
            { path: 'game', name: 'Game', component: function (resovle) { require(['./components/Game.vue'], resovle) } },
            { path: 'news', name: 'News', component: function (resovle) { require(['./components/News.vue'], resovle) } },
            { path: 'about', name: 'About', component: function (resovle) { require(['./components/About.vue'], resovle) } },
            { path: 'detail', name: 'Detail', component: function (resovle) { require(['./components/Detail.vue'], resovle) } },
            { path: 'announce', name: 'Announce', component: function (resovle) { require(['./components/announce/Announce.vue'], resovle) } },
        ]
    },
    { path: '/404', name: '404', component: NotFound }
];

export default routes;
